import React, { useContext } from 'react';
import { SubmitFormContext } from '../../../context';
import SingleImagePreview from '../SingleImagePreview';
import MultiImagePreview from '../MultiImagePreview';

interface Props {
  className?: string;
}

const ReplaceableImagePreview: React.FC<Props> = props => {
  const { initResponse } = useContext(SubmitFormContext)!;
  const canBeMultiImage = initResponse?.deviation?.canBeMultiImage;

  if (canBeMultiImage) {
    return <MultiImagePreview {...props} />;
  }

  return <SingleImagePreview {...props} />;
};
ReplaceableImagePreview.displayName = 'ReplaceableImagePreview';

export default ReplaceableImagePreview;
